import { Injectable } from '@angular/core';
import { ELEMENT as STRING_ELEMENT, StringDtypeComponent } from '../components/dtypes/string-dtype/string-dtype.component';
import { ELEMENT as NUMBER_ELEMENT, NumberDtypeComponent } from '../components/dtypes/number-dtype/number-dtype.component';
import { ELEMENT as LINK_ELEMENT, LinkDtypeComponent } from '../components/dtypes/link-dtype/link-dtype.component';
import { ELEMENT as DATETIME_ELEMENT, DatetimeDtypeComponent } from '../components/dtypes/datetime-dtype/datetime-dtype.component';
import { ELEMENT as LAST_CHANGE_ELEMENT, LastChangeDtypeComponent } from '../components/dtypes/last-change-dtype/last-change-dtype.component';
import { ELEMENT as PRODUCT_NAME_ELEMENT, ProductNameDtypeComponent } from '../components/dtypes/product-name-dtype/product-name-dtype.component';
import { ELEMENT as LAYOUT_PARAMS_ELEMENT, LayoutParamsDtypeComponent } from '../components/dtypes/layout-params-dtype/layout-params-dtype.component';
import { ELEMENT as PLAN_STATUS_BUTTON_ELEMENT, PlanStatusButtonDtypeComponent } from '../components/dtypes/plan-status-button-dtype/plan-status-button-dtype.component';
import { ELEMENT as PRODUCT_LIST_ADD_BUTTON_ELEMENT, ProductListAddButtonDtypeComponent } from '../components/dtypes/product-list-add-button-dtype/product-list-add-button-dtype.component';
import { ELEMENT as TOOLTIP_ELEMENT, TooltipDtypeComponent } from '../components/dtypes/tooltip-dtype/tooltip-dtype.component';
import { ELEMENT as DEADLINE_DATE_ELEMENT, DeadlineDateDtypeComponent } from '../components/dtypes/deadline-date-dtype/deadline-date-dtype.component';
import { ELEMENT as PRODUCT_POSITION_ELEMENT, ProductPositionDtypeComponent } from '../components/dtypes/product-position-dtype/product-position-dtype.component';
import { DType } from '../models/table';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class TableService {

	dtype: DType;
	dtypeElement: { [key: string]: any };

	constructor(private http: HttpClient) {
		this.dtype = {
			'string': StringDtypeComponent,
			'number': NumberDtypeComponent,
			'link': LinkDtypeComponent,
			'datetime': DatetimeDtypeComponent,
			'date': DatetimeDtypeComponent,
			'last_change': LastChangeDtypeComponent,
			'product_name': ProductNameDtypeComponent,
			'layout_params': LayoutParamsDtypeComponent,
			'plan_status_button': PlanStatusButtonDtypeComponent,
			'tooltip': TooltipDtypeComponent,
			'product_list_add_button': ProductListAddButtonDtypeComponent,
			'deadline_date': DeadlineDateDtypeComponent,
			'mp_product_position': ProductPositionDtypeComponent
		};
		this.dtypeElement = {
			'string': STRING_ELEMENT,
			'number': NUMBER_ELEMENT,
			'link': LINK_ELEMENT,
			'datetime': DATETIME_ELEMENT,
			'date': DATETIME_ELEMENT,
			'last_change': LAST_CHANGE_ELEMENT,
			'product_name': PRODUCT_NAME_ELEMENT,
			'layout_params': LAYOUT_PARAMS_ELEMENT,
			'plan_status_button': PLAN_STATUS_BUTTON_ELEMENT,
			'tooltip': TOOLTIP_ELEMENT,
			'product_list_add_button': PRODUCT_LIST_ADD_BUTTON_ELEMENT,
			'deadline_date': DEADLINE_DATE_ELEMENT,
			'mp_product_position': PRODUCT_POSITION_ELEMENT
		};
	}

	getNextTablePage<T, F>(method: 'GET' | 'POST', url: string, filters: Partial<F> = {}): Observable<T> {
		return this.http.request<T>(method, url, { body: filters });
	}

	getType(dtype: string, element): string {
		return dtype === 'object' ? element.dtype : dtype;
	}
}